/**
 * 処理中のアニメーションを表示します。
 *
 * @returns 処理中を表示する要素
 */
export const showBusy = (): Element | null => {
  const element = document.querySelector(".rsi-busy");
  if (element) {
    element.classList.add("is-opened");
  }
  return element;
};

/**
 * 処理中のアニメーションを非表示にします。
 *
 * @param elem - 表示中の要素
 */
export const hideBusy = (elem?: Element | null): void => {
  const element = elem ? elem : document.querySelector(".rsi-busy");
  if (element) {
    element.classList.remove("is-opened");
  }
};
